import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../../../core/models/user';
import { ExtendedDrawerItem, LayoutConfig } from '../../../core/components/app-layout/layout-config';
import { buildNavItems, FLAG_GATED_ROUTES, INFO_NAV } from './customer-layout-nav.config';
import { partnerAccess } from '../../partner/access/partner-access';

export const customerLayoutConfig: LayoutConfig = {
  menuItemsFactory: (user: User, flags?: Record<string, boolean>): ExtendedDrawerItem[] =>
    buildNavItems(
      {
        primaryOrgId: user.primary_organization?.id,
        primaryOrgAccountType: user.primary_organization?.account_type,
        groups: user.groups,
        partnerPortal: partnerAccess().portal,
      },
      flags ?? {},
    ),

  footer: {
    showVipSupport: true,
    showResources: true,
    showNotifications: true,
    showSettings: true,
    showUserAvatar: true,
  },

  userMenuItemsFactory: (user: User) => {
    if (user.groups.includes('admin')) {
      return [
        { text: 'Admin Console', icon: 'settings' },
        { text: 'Logout', icon: 'log-out' },
      ];
    }
    return [{ text: 'Logout', icon: 'log-out' }];
  },

  onOrgChange: (event: any, router: Router, _route: ActivatedRoute) => {
    const queryParams: { organizationId: number; account_type?: number } = {
      organizationId: event.id,
    };
    if (event.account_type != null) {
      queryParams.account_type = event.account_type;
    }
    router.navigate([], {
      relativeTo: router.routerState.root,
      queryParams,
      queryParamsHandling: 'merge',
    });
  },

  workspace: 'one',
  settingsRoute: '/customer/customer-settings',

  resourceLinks: INFO_NAV,

  scripts: {
    injectZoho: false,
    removeChatWidget: false,
  },

  onUserProfileAction: (actionText: string, router: Router) => {
    if (actionText === 'Admin Console') {
      router.navigate(['/admin/dashboard']);
    }
  },

  // Feature flags: enables reactive nav rebuilding and flag-gated route redirects
  enableFeatureFlags: true,
  flagGatedRoutes: FLAG_GATED_ROUTES,
  defaultRedirectRoute: '/customer/customer-dashboard',

  // Support widget: SupportWidgetService handles Zoho/Support Bridge lifecycle
  enableSupportWidget: true,
};
